import router from '@/router'
import { allowOnlyGuests } from '@/router/routerGuards'

export default () => {
  router.addRoute({
    path: '/xero',
    component: () => import('../../components/OnboardingWrapper.vue'),
    children: [
      {
        path: '', // Empty path for default child route
        components: {
          default: () => import('./components/XeroLandingPage.vue'),
          geometricBackground: () => import('../../components/GeometricBackground.vue')
        },
        beforeEnter: allowOnlyGuests(),
        name: 'xero', // Use a name for the default child route
        alias: ['/xerosignup', '/xero/callback']
      }
    ]
  })
}
